<script lang="ts">
	// shadcn-svelte ToggleGroup, on the genuine bits-ui ToggleGroup primitive but
	// RESTYLED to the price-check "segmented pill" look (a bordered container with
	// gapped items; the active item is brand-filled). The stock joined-segment /
	// spacing / orientation complexity + arbitrary values are dropped — we only use
	// the single-select horizontal pill. NO arbitrary `[..]` values.
	import { ToggleGroup as ToggleGroupPrimitive } from "bits-ui";
	import { cn } from "../../../utils.js";

	let {
		ref = $bindable(null),
		value = $bindable(),
		class: className,
		...restProps
	}: ToggleGroupPrimitive.RootProps = $props();
</script>

<ToggleGroupPrimitive.Root
	bind:value={value as never}
	bind:ref
	data-slot="toggle-group"
	class={cn(
		"inline-flex w-fit items-center gap-1 rounded-lg border border-border bg-surface p-1",
		className
	)}
	{...restProps}
/>
